import { ReadingInventoryNav } from 'src/pages/ClinicalTrial/Readings/ReadingInventory/ReadingInventoryNav';
import { Outlet, useParams } from 'react-router-dom';
import { useClinicalTrialInventorySlice } from '@restore/clinicalTrialInventory/clinicalTrialInventory.slice';
import { useEffect } from 'react';
import { useTeamMembersListSlice } from '@restore/teamMembersList/teamMembersList.slice';

export const ReadingInventory = () => {
  const { id } = useParams();

  const fetchAllTeamMembers = useTeamMembersListSlice(
    (_, actions) => actions.fetchTeamMembersListAll
  );
  const [fetchClinicalTrialInventory] = useClinicalTrialInventorySlice(
    (_, actions) => [actions.fetchClinicalTrialUtilsInventory]
  );

  useEffect(() => {
    fetchClinicalTrialInventory(id as string);
    fetchAllTeamMembers({ clinicalTrialId: id as string });
  }, [id]);

  return (
    <div className={'flex h-full'}>
      <div>
        <ReadingInventoryNav />
      </div>
      <Outlet />
    </div>
  );
};
